import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { BasketQtyComponentDef } from '@df/basket/view/basket-qty.component.def';
import { TranslationModule } from '@df/ui/translation/translation.module';
@Component({
    selector: 'basket-qty',
    templateUrl: './basket-qty.html',
    standalone: true,
    imports: [TranslationModule, NgClass],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class BasketQtyComponent extends BasketQtyComponentDef {
    icon = input<string>('icon-basket');
}
